

import React, { useState } from 'react';
import { FaUser } from 'react-icons/fa';
import { HiChevronRight, HiChevronDown } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';

export default function Sidebar({ isOpen, toggleSidebar, onOpenAuth }) {
  const navigate = useNavigate();

  const [openCategory, setOpenCategory] = useState(null);
  const [openSubcategory, setOpenSubcategory] = useState(null);
 
  const categorys = [
    'Fruits',
    'Vegetables',
    'Bakery',
    'Desserts',
    'Fast Food',
    'Indian Dishes',
    'Meat',
    'Grains'
  ];

  const handleCategory = (category) => {
    navigate('/foodgallery', { state: { category } });
  };
  const categories = [
    {
      name: 'Mobiles',
      subcategories: [
        { name: 'Smartphones', subsubcategories: ['Samsung', 'Vivo', 'Redmi'] },
        { name: 'Feature Phones', subsubcategories: [] },
        { name: 'Accessories', subsubcategories: [] },
      ],
    },
    {
      name: 'Tools',
      subcategories: [
        { name: 'Power Tools', subsubcategories: [] },
        { name: 'Hand Tools', subsubcategories: [] },
        { name: 'Measuring Tools', subsubcategories: [] },
      ],
    },
    {
      name: 'Cleaning',
      subcategories: [
        { name: 'Household', subsubcategories: [] },
        { name: 'Industrial', subsubcategories: [] },
        { name: 'Car Cleaning', subsubcategories: [] },
      ],
    },
    {
      name: 'Mens Clothes',
      subcategories: [
        { name: 'Shirts', subsubcategories: [] },
        { name: 'Trousers', subsubcategories: [] },
        { name: 'Jackets', subsubcategories: [] },
      ],
    },
    {
      name: 'Cosmetics',
      subcategories: [
        { name: 'Makeup', subsubcategories: [] },
        { name: 'Skincare', subsubcategories: [] },
        { name: 'Fragrance', subsubcategories: [] },
      ],
    },
  ];

  const handleCategoryClick = (name) => {
    const slug = name.toLowerCase().replace(/\s+/g, '-');
    navigate(`/categories/${slug}`);
    toggleSidebar();
  };

  const toggleCategory = (name) => {
    setOpenCategory(openCategory === name ? null : name);
    setOpenSubcategory(null);
  };

  const toggleSubcategory = (name) => {
    setOpenSubcategory(openSubcategory === name ? null : name);
  };

  return (
    <>
      <div className={`sidebar ${isOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <div className="sidebar-header">
          <div className="d-flex align-items-center text-white p-3">
            <FaUser size={24} className="me-2" />
            <button className="fw-bold btn-link">
              Hello, sign in
            </button>
          </div>
        </div>

        <div className="sidebar-content">
          <div className="sidebar-section">
            <h6 className="sidebar-section-title">Trending</h6>
            <ul className="list-unstyled">
              <li><a href="#" className="sidebar-link">Bestsellers</a></li>
              <li><a href="#" className="sidebar-link">New Releases</a></li>
              <li><a href="#" className="sidebar-link">Movers and Shakers</a></li>
            </ul>
          </div>

          <hr className="sidebar-divider" />
 <div className="sidebar-section">
      <h6 className="sidebar-section-title">Food & Beverages</h6>
      <ul className="list-unstyled">
        {categorys.map(cat => (
          <li key={cat}>
            <button
              className="sidebar-link text-dark d-flex justify-content-between align-items-center"
              onClick={() => handleCategory(cat)}
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                color: 'inherit',
                textAlign: 'left',
                width: '100%',
                cursor: 'pointer'
              }}
            >
              <span>{cat}</span>
              <HiChevronRight size={16} />
            </button>
          </li>
        ))}
      </ul>
    </div>
  
          <div className="sidebar-section">
            <h6 className="sidebar-section-title">Digital Content and Devices</h6>
            <ul className="list-unstyled">
              {['Echo & Alexa', 'Fire TV', 'Kindle E-Readers & eBooks'].map(item => (
                <li key={item}>
                  <a href="#" className="sidebar-link d-flex justify-content-between align-items-center">
                    <span>{item}</span>
                    <HiChevronRight size={16} />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <hr className="sidebar-divider" />

          <div className="sidebar-section">
            <h6 className="sidebar-section-title">Shop by Category</h6>
            <ul className="list-unstyled">
              {categories.map(({ name: catName, subcategories }) => (
                <li key={catName}>
                  <button
                    onClick={() => toggleCategory(catName)}
                    className="sidebar-link d-flex justify-content-between align-items-center"
                    style={{ fontWeight: 'bold' }}
                  >
                    <span>{catName}</span>
                    {openCategory === catName ? <HiChevronDown size={16} /> : <HiChevronRight size={16} />}
                  </button>

                  {openCategory === catName && (
                    <ul className="list-unstyled ms-3">
                      {subcategories.map(({ name: subName, subsubcategories }) => (
                        <li key={subName}>
                          <button
                            onClick={() => {
                              if (subsubcategories.length > 0) {
                                toggleSubcategory(subName);
                              } else {
                                handleCategoryClick(subName);
                              }
                            }}
                            className="sidebar-link d-flex justify-content-between align-items-center"
                            style={{ paddingLeft: '24px', fontWeight: 'normal' }}
                          >
                            <span>{subName}</span>
                            {subsubcategories.length > 0 &&
                              (openSubcategory === subName ? <HiChevronDown size={16} /> : <HiChevronRight size={16} />)}
                          </button>

                          {openSubcategory === subName && subsubcategories.length > 0 && (
                            <ul className="list-unstyled ms-4">
                              {subsubcategories.map(subsub => (
                                <li key={subsub}>
                                  <button
                                    onClick={() => handleCategoryClick(subsub)}
                                    className="sidebar-link"
                                    style={{ paddingLeft: '32px', fontWeight: 'normal' }}
                                  >
                                    {subsub}
                                  </button>
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <style>{`
        .sidebar {
          width: 300px;
          height: 100vh;
          background-color: #fff;
          border-right: 1px solid #ddd;
          transition: margin-left 0.3s ease;
          position: fixed;
          left: 0;
          top: 0;
          z-index: 1000;
          overflow-y: auto;
        }
        .sidebar-open {
          margin-left: 0;
        }
        .sidebar-closed {
          margin-left: -300px;
        }
        .sidebar-header {
          background-color: #232f3e;
        }
        .sidebar-section-title {
          font-weight: bold;
          color: #333;
          padding: 12px 16px 8px;
          font-size: 18px;
        }
        .sidebar-link {
          width: 100%;
          text-align: left;
          padding: 12px 16px;
          border: none;
          background: none;
          color: #333;
          text-decoration: none;
          font-size: 14px;
          transition: background-color 0.2s ease;
          cursor: pointer;
        }
        .sidebar-link:hover, .btn-link:hover {
          background-color: #f3f3f3;
          text-decoration: none;
        }
        .btn-link {
          background: none;
          border: none;
          color: white;
          font-size: 1rem;
          cursor: pointer;
          padding: 0;
        }
        .sidebar-divider {
          margin: 0;
          border-color: #ddd;
        }
        .ms-3 {
          margin-left: 1rem;
        }
        .ms-4 {
          margin-left: 1.5rem;
        }
        @media (max-width: 768px) {
          .sidebar {
            width: 280px;
          }
        }
      `}</style>
    </>
  );
}
